// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Fpi4","large":"styles_large__X3Iv2"};